import type { ReactNode } from 'react';
import { cn } from '@/components/ui';

/** Подпись строки главного меню: уходит при сворачивании, не сдвигая значок (пункты, знак, «я»). */
export function MenuLabel({
  expanded,
  className,
  children,
}: {
  expanded: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'overflow-hidden text-left whitespace-nowrap transition-label',
        expanded ? 'max-w-48 flex-1 opacity-100 delay-100' : 'ml-0 max-w-0 opacity-0',
        className,
      )}
    >
      {children}
    </span>
  );
}
